import React from 'react';
import {observer} from 'mobx-react';
import RecruitingSubnav from '../RecruitingSubnav';
import {Panel, TextArea, FormLayout, Button, ObjectSelect2, Layout, EmployeeNameWithAvatar, Select2} from 'components';
import {withState} from 'shared/core';
import AiScreenerContainerState from './AiScreenerContainerState';
import CandidateRater from '../hiring_funnel/CandidateRater';

const CandidateResult = observer(({position, candidateResult}) => {
  return (
    <div className='flex justify-content-between'>
      <div>
        <EmployeeNameWithAvatar to={`/positions/${position.id}/funnel/${candidateResult.candidate.id}`} employee={candidateResult.candidate}/>
        <div className='mt1 jumbo'>{candidateResult.explanation}</div>
      </div>
      <CandidateRater score={candidateResult.rating}/>
    </div>
  );
});

const CandidateResults = observer(({position, candidateResults, readyCandidateCount, totalCandidateCount}) => {
  if (candidateResults.length === 0) {
    return null;
  }

  return (
    <Panel className='mt2 space-y-3'>
      <Panel.Header title={`${readyCandidateCount}/${totalCandidateCount} candidates processed`}/>
      {candidateResults.map(candidateResult => <CandidateResult position={position} candidateResult={candidateResult}/>)}
    </Panel>
  );
});

const RequestForm = observer(({uiState}) => {
  const {request, labelledPositions} = uiState;

  return (
    <Panel>
      <FormLayout>
        <ObjectSelect2
          className='full-width'
          label='Position'
          value={request.position}
          items={labelledPositions}
          onChange={value => request.merge({position: value})}
          display='title'
        />
        <TextArea
          label='Prompt'
          value={request.prompt}
          onChange={(e) => request.merge({prompt: e.target.value})}
          placeholder='Enter your prompt here'
          minRows={5}
        />
        <Select2
          label='Model'
          value={request.model}
          onChange={e => request.merge({model: e.target.value})}
          placeholder='GPT Model'
        >
          <option key='gpt-4.1' value='gpt-4.1'>{'gpt-4.1'}</option>
          <option key='gpt-4.1-mini' value='gpt-4.1-mini'>{'gpt-4.1-mini'}</option>
          <option key='gpt-4.1-nano' value='gpt-4.1-nano'>{'gpt-4.1-nano'}</option>
        </Select2>
        <Button className='' onClick={() => uiState.submitRequest()}>
          {'Run'}
        </Button>
      </FormLayout>
    </Panel>
  );
});

const AiScreenerContainer = observer(({uiState}) => {
  const {sortedCandidateResults} = uiState;

  return (
    <div>
      <RecruitingSubnav/>
      <Layout>
        <RequestForm uiState={uiState}/>
        <CandidateResults
          position={uiState.request.position}
          candidateResults={sortedCandidateResults}
          readyCandidateCount={uiState.candidateResults.length}
          totalCandidateCount={uiState.request.totalCandidateCount}
        />
      </Layout>
    </div>
  );
});

export default withState(AiScreenerContainer, AiScreenerContainerState);
